// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n[data-v-13658ec2]:root{\n  --header-height-sm:80px;\n  --header-height:96px\n}\n.input-field:focus+label[data-v-13658ec2]{\n  --tw-translate-y:0px;\n  font-size:0.875rem;\n  line-height:1.25rem\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
